import { getRequest, postRequest, putRequest } from '@bo-apis/axios';
import NOTIFICATION from '../../options/customerService/notificationsConst';

const getNotificationList = ({ form, pageable }) =>
  postRequest({
    url: `${NOTIFICATION.URL}/get-notification-list`,
    params: { ...pageable },
    data: { ...form },
  });

const getAllNotificationList = ({ form }) =>
  postRequest({
    url: `${NOTIFICATION.URL}/get-notification-list`,
    data: { ...form },
  });

const createNotification = (form) =>
  postRequest({
    url: NOTIFICATION.URL,
    data: { ...form },
  });

const updateNotification = (form) =>
  putRequest({
    url: NOTIFICATION.URL,
    data: { ...form },
  });

const getNotification = (notificationSeq) =>
  getRequest({
    url: `${NOTIFICATION.URL}/${notificationSeq}`,
  });

const updateNotificationList = (gridData) =>
  postRequest({
    url: `${NOTIFICATION.URL}/update-notification-list`,
    data: { ...gridData },
  });

export {
  getNotificationList,
  getAllNotificationList,
  createNotification,
  updateNotification,
  getNotification,
  updateNotificationList,
};
